import { memo } from 'react';
import './SliderDot.scss';
import { jsx } from 'react/jsx-runtime';

/* External */
function SliderDot(_ref) {
  var className = _ref.className,
    style = _ref.style,
    children = _ref.children;
  return /*#__PURE__*/jsx("span", {
    className: "dtv-common-c-slider-dot ".concat(className),
    style: style,
    children: children
  });
}
SliderDot.defaultProps = {
  className: '',
  style: undefined,
  children: null
};
var SliderDot$1 = /*#__PURE__*/memo(SliderDot);

export { SliderDot$1 as default };
//# sourceMappingURL=SliderDot.js.map
